import React from 'react';
import { ChevronRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <div
      className="relative h-80 bg-cover bg-center flex items-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80)',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-white animate-fadeInUp">
          <div className="flex items-center text-sm mb-4">
            <span className="opacity-90">Accueil</span>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="opacity-90">Terrains</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight">Nos terrains</h1>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;